import React, { useId } from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { getMessage } from "../data/locales";
import {
  buildLegalDocumentLinkExtras,
  buildLegalDocumentTo,
  getLegalFlowReturn,
} from "../utils/legalFlowReturn";
import "./ConsentCheckbox.css";

const noop = () => {};

const ConsentCheckbox = ({
  checked = false,
  onChange = noop,
  error = "",
  openLinksInNewTab = false,
  returnTo = "",
  returnLabel = "",
}) => {
  const errorId = useId();
  const location = useLocation();
  const flowReturn = getLegalFlowReturn(location.pathname, location.search);
  const resolvedReturnTo = returnTo || flowReturn.returnTo;
  const resolvedReturnLabel = returnLabel || flowReturn.returnLabel;
  const resolvedOpenInNewTab = openLinksInNewTab || flowReturn.openLinksInNewTab;
  const resolvedFlow = {
    returnTo: resolvedReturnTo,
    returnLabel: resolvedReturnLabel,
    openLinksInNewTab: resolvedOpenInNewTab,
  };
  const linkExtras = buildLegalDocumentLinkExtras(resolvedFlow);
  const newTabTitle = resolvedOpenInNewTab
    ? getMessage("legal.opensInNewTab")
    : undefined;

  return (
    <div className="consent-checkbox">
      <label className="consent-label">
        <input
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          required
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
        />
        <span>
          Acepto los{" "}
          <Link to={buildLegalDocumentTo("/terminos", resolvedFlow)} title={newTabTitle} {...linkExtras}>
            {getMessage("legal.terms")}
          </Link>
          {" "}y la{" "}
          <Link to={buildLegalDocumentTo("/privacidad", resolvedFlow)} title={newTabTitle} {...linkExtras}>
            {getMessage("legal.privacy")}
          </Link>
        </span>
      </label>
      {error && (
        <span id={errorId} className="consent-error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

ConsentCheckbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  error: PropTypes.string,
  openLinksInNewTab: PropTypes.bool,
  returnTo: PropTypes.string,
  returnLabel: PropTypes.string,
};

export default ConsentCheckbox;
